module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#group",
      toString: function () {
        return this.url;
      }
    }